import { render, staticRenderFns } from "./OwnerPropertyView.vue?vue&type=template&id=51dd75f6&scoped=true"
import script from "./OwnerPropertyView.vue?vue&type=script&lang=js"
export * from "./OwnerPropertyView.vue?vue&type=script&lang=js"
import style0 from "./OwnerPropertyView.vue?vue&type=style&index=0&id=51dd75f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dd75f6",
  null
  
)

export default component.exports